import React from 'react';
import { StatisticColorByStepCalc } from '@app/utils/statistic-color-by-step';

export const DisplayScoreComponent = ({ score, color, maxScore = 0, fullFilled = false }) => {
  return (
    <div
      style={
        fullFilled
          ? { background: color || StatisticColorByStepCalc({ max: maxScore, score }) }
          : { borderLeftColor: color || StatisticColorByStepCalc({ max: maxScore, score }) }
      }
      className={`flex text-[14px] items-center justify-center w-[65px] h-[45px] rounded-defaultR bg-bg_3 ${
        !fullFilled && 'border-l-solid border-l-[2px]'
      }`}
    >
      <b className="text-[14px]">{score}</b>&nbsp;/&nbsp;{maxScore}
    </div>
  );
};
